import React from 'react'
import PropTypes from 'prop-types'

import { Background, SpinnerBlock, Spinner, LoadingText } from "./loadingScreenStyles"

const LoadingScreen = ({ text }) => (
    <Background>

        <SpinnerBlock>

            <Spinner />

            { text && <LoadingText>{ text }</LoadingText> }
        
        </SpinnerBlock>

    </Background>
)

LoadingScreen.propTypes = {
    text: PropTypes.string
}

export default LoadingScreen    